import { TPropertyCardPropertyData } from '@/card/card-types';
import { hideData, validateAddress } from '@/card/card-utils';
import { numberStartsWithDollarSign } from '@/utils/string-utils';
import { PresentationalPropertyCardBody } from './presentational-property-card-body';

interface Props extends TPropertyCardPropertyData {
  printMode: boolean;
  isContentHidden?: boolean;
}

export function PropertyCardBody(props: Props) {
  const {
    latestRevenue,
    bedrooms,
    bathrooms,
    apn,
    address,
    printMode,
    isContentHidden = false,
  } = props;

  const detailItems = {
    ...props,
    bed: !isContentHidden && bedrooms,
    bath: !isContentHidden && bathrooms,
    revenue: hideData(
      isContentHidden,
      numberStartsWithDollarSign,
      latestRevenue
    ),
    type: !isContentHidden && props.residentialType,
    apn,
  };

  return (
    <PresentationalPropertyCardBody
      displayedAddress={validateAddress(address)}
      detailItems={detailItems}
      printMode={printMode}
    />
  );
}
